/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_hero_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your command center for specialized tools`)
};

const es_home_hero_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu centro de comando para herramientas especializadas`)
};

const de_home_hero_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Kommandozentrum für spezialisierte Werkzeuge`)
};

const nl_home_hero_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw commandocentrum voor gespecialiseerde tools`)
};

const fr_home_hero_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre centre de commande pour des outils spécialisés`)
};

const it_home_hero_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo centro di comando per strumenti specializzati`)
};

const pt_br2_home_hero_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu centro de comando para ferramentas especializadas`)
};

const pt_home_hero_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O seu centro de comando para ferramentas especializadas`)
};

const ja_home_hero_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`専門ツールのためのコマンドセンター`)
};

const zh_home_hero_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的专业工具指挥中心`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_hero_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_hero_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_hero_title", locale)
	if (locale === "en") return en_home_hero_title(inputs)
	if (locale === "es") return es_home_hero_title(inputs)
	if (locale === "de") return de_home_hero_title(inputs)
	if (locale === "nl") return nl_home_hero_title(inputs)
	if (locale === "fr") return fr_home_hero_title(inputs)
	if (locale === "it") return it_home_hero_title(inputs)
	if (locale === "pt-BR") return pt_br2_home_hero_title(inputs)
	if (locale === "pt") return pt_home_hero_title(inputs)
	if (locale === "ja") return ja_home_hero_title(inputs)
	return zh_home_hero_title(inputs)
};